import React from "react";

const renderDimension = (whole, fraction) => {
  if (!fraction) {
    return (
      <>
        {whole}
        <span>&quot;</span>
      </>
    );
  }

  return (
    <>
      <span>{whole}</span>
      <span className="badge-size-fraction"> {fraction}</span>
      <span>&quot;</span>
    </>
  );
};

const BadgeSizeLabel = ({ size }) => {
  if (size.displayMmOnly) {
    return <>{size.displaySizeInMm}</>;
  }

  return (
    <>
      {renderDimension(size.displayWidth, size.displayWidthFraction)}
      {" × "}
      {renderDimension(size.displayHeight, size.displayHeightFraction)}
    </>
  );
};

export default BadgeSizeLabel;
